import { render, staticRenderFns } from "./MsgCenter.vue?vue&type=template&id=908b6da8&"
import script from "./MsgCenter.vue?vue&type=script&lang=js&"
export * from "./MsgCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports